<div class="full-screen-video-wrapper" *ngIf="fullScreenViewer.videoPlayerEnabled && fullScreenViewer.videoUrl">
  <ion-button color="white" shape="round" class="close-button" (click)="cancel()">
    <ion-icon name="close-circle-outline"></ion-icon>
  </ion-button>
  <video [src]="fullScreenViewer.videoUrl" autoplay controls controlsList="nofullscreen"></video>
</div>